class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form[data-type="add-to-cart-form"]');
    this.submitButtons = this.querySelectorAll(".button-addtocart");

    this.submitButtons.forEach((button) => {
      button.addEventListener("click", this.onSubmitButtonClick.bind(this));
    });
  }

  async onSubmitButtonClick(evt) {
    evt.preventDefault();
    const button = evt.currentTarget;
    button.disabled = true;

    try {
      if (!this.form) throw new Error("Add-to-cart form not found");

      await this.addProduct(new FormData(this.form));

      const upsellDrawer = document.querySelector("ek-upsell-drawer");
      if (upsellDrawer && upsellDrawer.dataset.hasItems === "true" && typeof upsellDrawer.open === "function" && upsellDrawer.open()) {
        return;
      }

      if (typeof window.openCartDrawerGlobal === "function") {
        window.openCartDrawerGlobal();
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      button.disabled = false;
    }
  }

  async addProduct(data) {
    const quantity = Number(data.get("quantity"));
    if (!data.has("id") || quantity <= 0) throw new Error("Invalid product or quantity");

    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: data,
    });

    if (!response.ok) {
      const payload = await response.json().catch(() => null);
      throw new Error(payload?.description || payload?.message || `Cart request failed (${response.status})`);
    }

    return await response.json();
  }
}

class ButtonShowVideo extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onClickHandler.bind(this));
  }

  onClickHandler(evt) {
    const mediaGallery = document.querySelector(`[id^="swiper-controller-${this.dataset.section}"]`);
    mediaGallery.slideToLast();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

customElements.define("product-form", ProductForm);
customElements.define("button-show-video", ButtonShowVideo);
